import { render, staticRenderFns } from "./ItemL_List_PackagingList_List.vue?vue&type=template&id=49aaa58d"
import script from "./ItemL_List_PackagingList_List.vue?vue&type=script&lang=js"
export * from "./ItemL_List_PackagingList_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports